import { Injectable } from '@angular/core';
import { GhiseuModuleService } from '../layout/pages-layout/nomenclatoare/ghiseul-unic/ghiseul-unic-settings/ghiseu-module/ghiseu-module.service';
import { ModuleLocatiiService } from '../layout/pages-layout/nomenclatoare/ghiseul-unic/ghiseul-unic-settings/module-locatii/module-locatii.service';
import { forkJoin, map, ReplaySubject } from 'rxjs';
import { Generic } from '../interfaces/generic.interface';

interface LocatieActiva {
    id: number,
    id_modul: number,
    id_locatie: number,
    nume_modul: string,
    nume_locatie: string,
}

@Injectable({
    providedIn: 'root'
})
export class SidenavService {
    private ghiseuModules: Generic[] = [];
    private ghiseuLocatiiActive: LocatieActiva[] = [];

    private sidenavDataFetched$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

    constructor(
        private ghiseuModuleService: GhiseuModuleService,
        private ghiseuModuleLocatiiService: ModuleLocatiiService,
    ) { }

    loadGhiseuModules() {
        return this.ghiseuModuleService.getModuleActive().pipe(
            map((results: any) => [...results.data]),
        );
    }

    loadGhiseuLocatiiActive() {
        return this.ghiseuModuleLocatiiService.getModuleLocatii().pipe(
            map((results: any) => [...results.data]),
        );
    }

    storeSidenavData() {
        return forkJoin({
            ghiseuModules: this.loadGhiseuModules(),
            ghiseuLocatiiActive: this.loadGhiseuLocatiiActive(),
        }).subscribe({
            next: (result: { ghiseuModules: Generic[]; ghiseuLocatiiActive: LocatieActiva[] }) => {
                this.ghiseuModules = result.ghiseuModules;
                this.ghiseuLocatiiActive = result.ghiseuLocatiiActive;

                this.sidenavDataFetched$.next(true);
            },
            error: (err: any) => {
                console.log(err);
                // In case of error just let the app to run
                this.sidenavDataFetched$.next(true);
            },
        });
    }

    getGhiseuModules() {
        return this.ghiseuModules;
    }

    getGhiseuLocatiiActive() {
        return this.ghiseuLocatiiActive;
    }

    isSidenavDataFetched$() {
        return this.sidenavDataFetched$;
    }
}
